import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { parse, isValid } from 'date-fns';

@Component({
  selector: 'app-date-view-item',
  templateUrl: './date-view-item.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./date-view-item.component.less']
})
export class DateViewItemComponent implements OnChanges{
  @Input() text: string = '';
  @Input() class: string = '';
  @Input() borderless = false;
  @Input() format: string = 'dd/MM/yyy HH:mm:ss';
  
  @Input() tabindex:string | null = null;

  date: WritableSignal<Date|null> = signal(null);

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      const parsedDate = parse(this.text, this.format, new Date());

      if (isValid(parsedDate))
        this.date.set(parsedDate);
      else
        this.date.set(null);
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}
